import { render, staticRenderFns } from "./IndexManageItem.vue?vue&type=template&id=ffac9264&scoped=true&"
import script from "./IndexManageItem.vue?vue&type=script&lang=js&"
export * from "./IndexManageItem.vue?vue&type=script&lang=js&"
import style0 from "./IndexManageItem.vue?vue&type=style&index=0&id=ffac9264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffac9264",
  null
  
)

export default component.exports